// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"c14d4ba4","234":"c14d4ba4","254":"c14d4ba4","700":"c14d4ba4","752":"c14d4ba4","842":"c14d4ba4","918":"c14d4ba4","928":"c14d4ba4","976":"c14d4ba4"}[chunkId] + ".chunk.css";
};